export default {
  'menu.welcome': 'Bienvenido',
  'menu.more-blocks': 'Más Bloques',
  'menu.home': 'Inicio',
  'menu.Home': 'Home',
  'menu.Inicio': 'Home',
  'menu.Analítica': 'Analítica',
  'menu.admin': 'Administrador',
  'menu.Administrador': 'Administrator',
  'menu.admin.sub-page': 'Subpágina',
  'menu.login': 'Iniciar sesión',
  'menu.register': 'Registrarse',
  'menu.register-result': 'Resultado de registro',
  'menu.dashboard': 'Panel',
  'menu.dashboard.analysis': 'Análisis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Lugar de trabajo',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulario',
  'menu.form.basic-form': 'Formulario Básico',
  'menu.form.step-form': 'Formulario de pasos',
  'menu.form.step-form.info': 'Formulario de pasos (escribir información de transferencia)',
  'menu.form.step-form.confirm': 'Formulario de pasos (confirmar información de transferencia)',
  'menu.form.step-form.result': 'Formulario de pasos (finalizado)',
  'menu.form.advanced-form': 'Formulario Avanzado',
  'menu.list': 'Lista',
  'menu.list.table-list': 'Administrativo',
  'menu.list.basic-list': 'Lista Básica',
  'menu.list.card-list': 'Lista de Tarjetas',
  'menu.list.search-list': 'Lista de Búsqueda',
  'menu.list.search-list.articles': 'Lista de Búsqueda (artículos)',
  'menu.list.search-list.projects': 'Lista de Búsqueda (proyectos)',
  'menu.list.search-list.applications': 'Lista de Búsqueda (aplicaciones)',
  'menu.profile': 'Perfil',
  'menu.profile.basic': 'Perfil Básico',
  'menu.profile.advanced': 'Perfil Avanzado',
  'menu.result': 'Resultado',
  'menu.result.success': 'Éxito',
  'menu.result.fail': 'Fallo',
  'menu.exception': 'Excepción',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Activar',
  'menu.account': 'Cuenta',
  'menu.account.center': 'Centro de Cuenta',
  'menu.account.settings': 'Configuración de Cuenta',
  'menu.account.trigger': 'Disparar Error',
  'menu.account.logout': 'Cerrar sesión',
  'menu.editor': 'Editor Gráfico',
  'menu.editor.flow': 'Editor de Flujo',
  'menu.editor.mind': 'Editor de Mapas Mentales',
  'menu.editor.koni': 'Koni Editor',
  'menu.Tableros': 'Tableros',
  'menu.Dashboard B2B': 'Dashboard B2B',
  'menu.Operación': 'Operación',
  'menu.Proyectos': 'Proyectos',
  'menu.Clientes Potenciales': 'Clientes Potenciales',
  'menu.Presupuestos': 'Presupuestos',
  'menu.Consulta': 'Consultas',
  'menu.Consultas': 'Consultas',
  'menu.Pedidos': 'Pedidos',
  'menu.Facturas': 'Facturas',
  'menu.Notas Crédito': 'Notas Crédito',
  'menu.Mis Clientes': 'Mis Clientes',
  'menu.Clientes Disponibles': 'Clientes Disponibles',
  'menu.Reportes': 'Reportes',
  'menu.Reporte Pedidos': 'Reporte de Pedidos',
  'menu.Reporte Facturas': 'Reporte de Facturas',
  'menu.Planeación Global': 'Planeación Global',
  'menu.Analytics': 'Analítica',
  'menu.Actividades': 'Actividades',
  'menu.Crear Stickers': 'Crear Stickers',
  'menu.Pedidos SIESA': 'Pedidos SIESA',
  'menu.Reporte Pedidos Local': 'Reporte Pedidos Local',
  'menu.Consultar Stock': 'Consultar Stock',
};
